import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=20a953bb&scoped=true"
var script = {}
import style0 from "./WaitView.vue?vue&type=style&index=0&id=20a953bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a953bb",
  null
  
)

export default component.exports